import React from 'react';
import EventTypesStaticContainer from '../../../Containers/UserContainer/EventTypesStaticContainer/EventTypesStaticContainer';

const EventTypesStaticScreen = () => {
  return <EventTypesStaticContainer />;
};

export default EventTypesStaticScreen;
